import { render, staticRenderFns } from "./Sentiments.vue?vue&type=template&id=a03579a8&scoped=true"
import script from "./Sentiments.vue?vue&type=script&lang=js"
export * from "./Sentiments.vue?vue&type=script&lang=js"
import style0 from "./Sentiments.vue?vue&type=style&index=0&id=a03579a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03579a8",
  null
  
)

export default component.exports